import { ChangeDetectionStrategy, Component, output } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';

@Component({
  selector: 'app-flowpilot-icon',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgOptimizedImage],
  styles: [
    `
      .fp-icon-btn {
        transition: transform 0.2s ease;
      }

      .fp-icon-btn:active {
        transform: scale(0.9);
      }
    `,
  ],
  template: `
    <button
      class="fp-icon-btn flex size-full cursor-pointer items-center justify-center rounded-full"
      (click)="clicked.emit()">
      <img
        ngSrc="assets/images/icons/flow-pilot/gradient-F.svg"
        alt="Flow Pilot"
        height="22"
        width="22"
        style="filter: brightness(0) invert(1);" />
    </button>
  `,
})
export class FlowpilotIconComponent {
  /** OUTPUTS **/
  /****/
  readonly clicked = output<void>();
}
